import {
  postV1CompaniesCompanyIdProjectsEmails,
  ProjectEmail_Item_Create,
} from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { useCallback } from 'react';

import sendOutboundEmails, {
  OutboundEmailEntry,
  outboundEmailFields,
} from './sendOutboundEmails';

interface SendProjectEmailParams {
  companyId: string;
  emails: OutboundEmailEntry[];
}

export default function useProjectOutboundEmails() {
  const sendProjectEmail = useCallback(
    ({ companyId, emails }: SendProjectEmailParams) =>
      sendOutboundEmails({
        errorMessage: t('error_messages.projects.failed_to_request_quote_email'),
        send: () =>
          postV1CompaniesCompanyIdProjectsEmails({
            path: { 'company-id': companyId },
            body: {
              emails: emails.map((entry): ProjectEmail_Item_Create => ({
                ...outboundEmailFields(entry),
                project_ids: entry.ids,
              })),
            },
          }),
      }),
    [],
  );

  return { sendProjectEmail };
}
